import FullSizeBox from "../../../../../appfw/ui/components/FullSizeBox.tsx";
import {Typography} from "@mui/material";
import {useLocation} from "react-router-dom";
import {EventerConsoleNavigation} from "../../../../EventerConsoleNavigation.tsx";
import {useAccount} from "../Accounts.tsx";

export default function EmptyEventsFeedPage() {

    const location = useLocation()
    const account = useAccount()

    return (
        <FullSizeBox>
            <Typography variant={'h6'} sx={{marginTop: '6rem'}}>
                Keine Veranstaltungen
            </Typography>
            <Typography sx={{marginTop: '0.5 rem'}}>
                {EventerConsoleNavigation.accounts.account(account.id).importers.linkEl(location, "Verbinde Kalender")}
            </Typography>
        </FullSizeBox>
    )
}